import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';
import ContactFormModal from '../components/ContactFormModal';
import './Help.css';

const HELP_FAQ = [
  {
    question: 'Miten voin olla yhteydessä asiakaspalveluun?',
    answer: 'Asiakaspalveluun saat yhteyden klikkaamalla "Ota yhteyttä" painiketta, jonka voit löytää nettisivujemme alaosasta. Vaihtoehtoisesti voit lähettää meille sähköpostia: asiakaspalvelu@pussikuskit.fi.'
  },
  {
    question: 'Mistä löydän kuittini?',
    answer: 'Kaikki kuitit tehdyistä tilauksista löytyvät "Tilaukset ja kuitit" painikkeen takaa.\n\n1. Klikkaa vasemmassa yläkulmassa sijaitsevaa "hampurilais-valikkoa".\n\n2. Klikkaa "Tilaukset ja kuitit".'
  },
  {
    question: 'Mistä tiedän, että toimittaako suosikki yritykseni luokseni?',
    answer: 'Jos etsimäsi yritys löytyy Pussikuskien sivuilta listattuna joko Ravintolat tai Kaupat osiosta, voit tilata yritykseltä Pussikuskien kautta mikäli olet yrityksen toiminta alueen ulkopuolella yrityksen sivuille tulee punainen laatikko mikä kertoo teille siitä.'
  },
  {
    question: 'Mistä voin vaihtaa tiliäni koskevia tietoja, kuten salasanaa, tallennettuja osoitteita ja sähköpostia?',
    answer: 'Voit tarkastella ja muokata Pussikuskit -tilisi tietoja verkkosivuillamme kohdasta "Tili". 1. Klikkaa vasemmassa yläkulmassa sijaitsevaa "hampurilais-valikkoa".\n\n2. Klikkaa "Tili".\n\n3. Klikkaa kohdasta "Asetukset".'
  },
  {
    question: 'Miten voin seurata kuljetusta?',
    answer: 'Tilauksen tekemisen jälkeen kun Pussikuski ja Yritys ovat hyväksyneet tilauksesi. Pussikuskit.fi etusivulle tulee Ikkuna missä näkyy tilauksesi ajankohtaiset tiedot.'
  },
  {
    question: 'Mistä näen tämänhetkisen Pussikuskit saldoni?',
    answer: 'Pussikuskit -saldoasi voit tarkastella Lompakossa.\n\n1. Klikkaa vasemmassa yläkulmassa sijaitsevaa "hampurilais-valikkoa".\n\n2. Klikkaa kohdasta "Lompakko".'
  },
  {
    question: 'Miksi suosikki yritystäni ei löydy Ravintolat tai Kaupat listasta?',
    answer: 'Jos et löydä etsimääsi yritystä Pussikuskien valikoimasta, et voi tällä hetkellä tilata yritykseltä Pussikuskien kautta.\n\nPyrimme kuitenkin laajentamaan toimintaamme jatkuvasti.\n\nJos olet kiinnostunut yhteistyöstä Pussikuskien kanssa, tai tunnet jonkun kiinnostuneen, voit olla meihin yhteydessä sähköpostitse: asiakaspalvelu@pussikuskit.fi.'
  },
  {
    question: 'Miten voin tilata useammasta yrityksestä samaan aikaan?',
    answer: 'Useammalta yritykseltä tilaaminen samaan kuljetukseen ei ole mahdollista. Jos tahdot tilata kahdesta tai useammasta eri yrityksestä samaan aikaan, tulee tällöin tehdä erillinen tilaus jokaista yritystä kohden.'
  }
];

const Help = () => {
  const { t } = useTranslation();
  const [showContactModal, setShowContactModal] = useState(false);

  return (
    <div className="help-container">
      <SEO title={t('nav.help') || 'Ohje'} description="Ohjeet ja usein kysytyt kysymykset – tilaukset, toimitus, maksut ja asiakaspalvelu." path="/help" />
      <div className="container">
        <h1>{t('nav.help')}</h1>
        <p className="help-intro">
          {t('help.intro') || 'Find answers to common questions and get help with using Pussikuskit.'}
        </p>

        <div className="help-support-banner">
          <div className="help-support-banner-content">
            <span className="help-support-label">{t('help.customerSupport') || 'Asiakaspalvelu:'}</span>
            <a href="mailto:asiakaspalvelu@pussikuskit.fi" className="help-support-email">asiakaspalvelu@pussikuskit.fi</a>
          </div>
          <button
            type="button"
            className="help-contact-btn"
            onClick={() => setShowContactModal(true)}
          >
            {t('help.contact') || 'Ota yhteyttä'}
          </button>
        </div>

        <section className="help-faq">
          {HELP_FAQ.map((item, index) => (
            <div key={index} className="help-faq-item">
              <h2 className="help-faq-question">{item.question}</h2>
              <div className="help-faq-answer">
                {item.answer.split(/\n\n+/).map((paragraph, i) => (
                  <p key={i}>{paragraph.trim()}</p>
                ))}
              </div>
            </div>
          ))}
        </section>
      </div>
      <ContactFormModal
        isOpen={showContactModal}
        onClose={() => setShowContactModal(false)}
      />
    </div>
  );
};

export default Help;
